import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { Button } from '@mui/material';
import { CollectionPayload } from '@src/types/Collection';
import {
  deviceFilter,
  SiteTypes,
} from '@src/utils/defaultDataStubs/stubFilters';
import React, { Dispatch, SetStateAction } from 'react';

interface Props {
  setOpen: Dispatch<SetStateAction<boolean>>;
  setJsonPayload: Dispatch<SetStateAction<CollectionPayload | null>>;
}

function GenerateDevicesButton({
  setJsonPayload,
  setOpen,
}: Props): React.ReactElement {
  const json = deviceFilter(
    sessionStorage.getItem('siteType')
      ? (sessionStorage.getItem('siteType') as SiteTypes)
      : null,
  );
  const handleGenerateDevicesClick = () => {
    setJsonPayload(json);
    setOpen(true);
  };

  return (
    <Button
      component='label'
      variant='contained'
      onClick={handleGenerateDevicesClick}
    >
      <FormattedAlias id='Generate Devices' />
    </Button>
  );
}

export default GenerateDevicesButton;
